import { useElementBounding } from "@vueuse/core";
import { computed, watchEffect } from "vue";

import { getAbTestFeature } from "@solvari/ab-testing";

import "./stickyMenuDesktop.css";

function stickyMenuDesktop() {
  if (!getAbTestFeature<boolean>("sticky-menu-desktop").value) {
    return;
  }

  const menuDesktop = document.querySelector<HTMLElement>(".menu--desktop");

  if (!menuDesktop) {
    return;
  }

  const { top } = useElementBounding(menuDesktop);
  const isSticking = computed(() => top.value <= 0);

  watchEffect(() => {
    if (isSticking.value) {
      menuDesktop.classList.add("menu--desktop--sticky");
    } else {
      menuDesktop.classList.remove("menu--desktop--sticky");
    }
  });
}

export { stickyMenuDesktop };
